module.exports = __webpack_public_path__ + "static/img/ket-renewal-style-icon-01@w.6bace21.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ket-renewal/ket-renewal-style-icon-01@w.png
// module id = Pyca
// module chunks = 0